import { ActionCreator } from 'redux';

import { FileInfo } from '@dev/ee-api/ee-api-models';

import {
    UploadFilesAction,
    UploadFilesErrorAction,
    UploadFilesStartAction,
    UploadFilesSuccessAction,
    UploadFilesUpdateProgressAction,
    DeleteUploadedFileAction,
    UploadFilesActionMedia,
} from './types';

export const UploadFiles: ActionCreator<UploadFilesAction> = (file: File, expiresAfterDays?: number): UploadFilesAction => {
    return {
        type: '@@upload/UPLOAD_FILES',
        payload: {
            file,
            expiresAfterDays,
        },
    };
};

export const UploadFilesMedia: ActionCreator<UploadFilesActionMedia> = (file: File, expiresAfterDays?: number): UploadFilesActionMedia => {
    return {
        type: '@@uploadmedia/UPLOAD_FILES',
        payload: {
            file,
            expiresAfterDays,
        },
    };
};

export const UpdateProgress: ActionCreator<UploadFilesUpdateProgressAction> = (progress: number): UploadFilesUpdateProgressAction => {
    return {
        type: '@@upload/UPLOAD_FILE_PROGRESS_UPDATE',
        payload: {
            progress,
        },
    };
};

export const StartUpload: ActionCreator<UploadFilesStartAction> = (): UploadFilesStartAction => {
    return {
        type: '@@upload/UPLOAD_FILES_START',
    };
};

export const UploadError: ActionCreator<UploadFilesErrorAction> = (): UploadFilesErrorAction => {
    return {
        type: '@@upload/UPLOAD_ERROR',
    };
};

export const UploadSuccess: ActionCreator<UploadFilesSuccessAction> = (fileuploaded: FileInfo): UploadFilesSuccessAction => {
    return {
        type: '@@upload/UPLOAD_SUCCESS',
        payload: {
            fileuploaded,
        },
    };
};

export const DeleteUploadedFile: ActionCreator<DeleteUploadedFileAction> = (): DeleteUploadedFileAction => {
    return {
        type: '@@upload/DELETE_FILE',
        payload: {
            fileuploaded: null,
        },
    };
};
